
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Puffpanelroom() {



  const cardData =
  {
    keyword: 'Puff Panel Room Installation ',
    heading: 'Anjali Enterprises: Puff Panel Room Installation ',
    headingDescription: 'Anjali Enterprises specializes in the installation of high-quality puff panel rooms, offering durable and efficient insulation solutions for commercial, industrial, and residential spaces. Our services ensure your space remains energy-efficient and temperature-controlled, ideal for various applications such as cold storage and partition systems.',

    "topPlaces": [
        {
          "title": "Insulated Panel Room Design",
          "description": "We provide expert design services for insulated panel rooms, utilizing high-performance puff panels to create effective temperature-controlled environments. Our design solutions are tailored to meet specific needs, ensuring optimal insulation and functionality."
        },
        {
          "title": "Puff Panel Fabrication",
          "description": "Our team offers custom puff panel fabrication services, ensuring the panels meet the exact specifications required for your project. We use high-quality materials to fabricate panels that offer superior insulation, durability, and performance."
        },
        {
          "title": "Modular Puff Panel Rooms",
          "description": "Anjali Enterprises designs and installs modular puff panel rooms, which provide flexibility and easy reconfiguration for various applications. These rooms are perfect for businesses that require efficient and scalable space solutions."
        },
        {
          "title": "Cold Storage Rooms with Puff Panels",
          "description": "We specialize in the installation of cold storage rooms using puff panels, offering excellent insulation properties to maintain consistent temperatures. These rooms are ideal for storing perishable goods, pharmaceuticals, and more."
        },
        {
          "title": "High-Quality Puff Panel Installation",
          "description": "Our installation services focus on providing high-quality puff panel rooms that are durable and energy-efficient. We ensure a precise installation that meets industry standards for insulation, safety, and performance."
        },
        {
          "title": "Custom Puff Panel Solutions",
          "description": "We offer custom puff panel solutions for businesses with specific requirements. Whether it’s for a commercial space or industrial use, our team designs and installs tailored puff panel systems to meet your unique needs."
        },
        {
          "title": "Insulated Walls for Industrial Use",
          "description": "Our puff panels provide excellent insulation for industrial spaces, including warehouses, factories, and cold storage units. These insulated walls ensure optimal temperature control and reduce energy costs, making them ideal for industrial applications."
        },
        {
          "title": "Puff Panel Partition Services",
          "description": "We offer puff panel partition services to create separate zones within your commercial or industrial space. These partitions offer superior insulation while maintaining an open and accessible layout."
        },
        {
          "title": "Puff Panel Work for Commercial Spaces",
          "description": "Anjali Enterprises delivers efficient puff panel solutions for commercial spaces, offering soundproofing, insulation, and energy efficiency for offices, shops, and showrooms. Our puff panels ensure comfort and functionality while enhancing the aesthetics of your space."
        },
        {
          "title": "Durable Puff Panel Room Construction",
          "description": "We construct durable puff panel rooms designed to last. With a focus on quality and precision, we ensure that every puff panel room meets the highest standards for insulation and performance, suitable for a variety of industries and applications."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality puff panel room installation services. We specialize in providing durable and energy-efficient puff panels for creating insulated, soundproof, and temperature-controlled rooms for various residential and commercial purposes. Get in touch for expert installation and professional service. Serving Pune with top-notch puff panel room solutions tailored to your specific needs."
        }
      ],
      "tableData": [
        ["- Insulated panel room design", "- Puff panel fabrication"],
        ["- Modular puff panel rooms", "- Cold storage rooms with puff panels"],
        ["- High-quality puff panel installation", "- Custom puff panel solutions"],
        ["- Insulated walls for industrial use", "- Puff panel partition services"],
        ["- Puff panel work for commercial spaces", "- Durable puff panel room construction"],
        ["- Contact Anjali Enterprises for expert service", ""]
      ],


    "whychoose": [
  {
    "WhyChooseheading": "Expert Puff Panel Room Installation",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in designing and installing top-quality puff panel rooms for both residential and commercial spaces. Whether you're looking for enhanced insulation, soundproofing, or a modern aesthetic, our puff panels offer the ideal solution. With our expertise, we ensure the installation process is carried out with precision, providing a high-performing, stylish room that meets your specific needs."
  },
  {
    "WhyChooseheading": "Excellent Thermal and Acoustic Insulation",
    "WhyChoosedescription": "Puff panels are renowned for their exceptional thermal and acoustic insulation capabilities. By effectively maintaining a consistent internal temperature, they help keep spaces cool in the summer and warm in the winter. Additionally, the soundproofing qualities make them ideal for offices, homes, or industrial spaces where privacy, comfort, and noise reduction are key considerations."
  },
  {
    "WhyChooseheading": "Durable and Long-Lasting",
    "WhyChoosedescription": "Our puff panels are constructed from high-quality, durable materials that ensure long-lasting performance. These panels are resistant to wear, tear, and environmental factors, offering robust insulation and acoustic benefits for many years. With proper installation, your puff panel room will continue to perform efficiently without the need for frequent repairs or replacements."
  },
  {
    "WhyChooseheading": "Aesthetic Appeal and Versatility",
    "WhyChoosedescription": "Puff panels not only enhance the functionality of your space but also provide a sleek, modern aesthetic. Their versatile design options allow for customization to fit a wide variety of interior styles, whether you're aiming for a contemporary office, a cozy home office, or a high-end commercial space. Our team works closely with you to ensure the design of your puff panel room complements your overall vision."
  },
  {
    "WhyChooseheading": "Energy-Efficient",
    "WhyChoosedescription": "One of the key benefits of puff panels is their energy efficiency. By improving thermal insulation, they help maintain the desired temperature in your space, reducing the need for constant heating or cooling. This can significantly lower your energy consumption, making it a more sustainable and cost-effective solution for both residential and commercial properties."
  },
  {
    "WhyChooseheading": "Quick and Hassle-Free Installation",
    "WhyChoosedescription": "We understand that you value your time and space. That's why our team of experienced professionals ensures that your puff panel room is installed quickly, efficiently, and with minimal disruption to your daily activities. From start to finish, we manage every detail of the installation process, ensuring a smooth experience and timely completion without compromising on quality."
  },
  {
    "WhyChooseheading": "Customizable Sizes and Designs",
    "WhyChoosedescription": "At Anjali Enterprises, we recognize that each space has unique needs. That's why we offer customizable puff panel solutions that can be tailored to your exact specifications. Whether you're building a small, cozy office room, a large conference area, or a personalized home space, we provide design and sizing options that perfectly match your requirements, ensuring the perfect fit for your space."
  },
  {
    "WhyChooseheading": "Environmentally Friendly",
    "WhyChoosedescription": "We are committed to sustainability, which is why our puff panels are made from eco-friendly materials. These panels are recyclable, reducing your carbon footprint and contributing to a greener environment. By choosing puff panels for your room, you are not only enhancing insulation and comfort but also making an environmentally responsible choice."
  },
  {
    "WhyChooseheading": "Low Maintenance",
    "WhyChoosedescription": "Puff panel rooms are designed for durability and require minimal maintenance. The panels are easy to clean, resistant to dust, moisture, and stains, ensuring that your room stays in top condition with little effort. This low-maintenance feature makes puff panels a practical solution for busy spaces, reducing the need for frequent upkeep or repairs."
  },
  {
    "WhyChooseheading": "Cost-Effective Solution",
    "WhyChoosedescription": "Puff panel rooms provide a cost-effective way to enhance the insulation, aesthetic appeal, and functionality of your space. Not only are they affordable to install, but they also provide long-term value by reducing energy consumption and maintenance costs. At Anjali Enterprises, we offer competitive pricing and transparent estimates, ensuring that you get the best return on your investment without any unexpected expenses."
  }
]



  }

  const faqData = [
    {
      "question": "What is a puff panel room?",
      "answer": "A puff panel room is a space constructed using puff panels, which are insulated panels made from lightweight, durable materials. These panels provide superior thermal and acoustic insulation, making them ideal for both residential and commercial applications."
    },
    {
      "question": "What are the benefits of puff panels?",
      "answer": "Puff panels offer excellent thermal insulation, soundproofing, and energy efficiency. They help maintain a comfortable temperature and reduce noise, making them ideal for offices, homes, and industrial environments."
    },
    {
      "question": "Can puff panel rooms be customized?",
      "answer": "Yes, puff panel rooms can be fully customized in terms of size, design, and layout. Whether you're looking for a modern office space or a cozy home room, we can tailor the puff panel solution to meet your specific needs."
    },
    {
      "question": "How long does the installation of a puff panel room take?",
      "answer": "The installation time depends on the size and complexity of the room. However, our experienced team ensures quick and efficient installation with minimal disruption to your space."
    },
    {
      "question": "Are puff panels energy-efficient?",
      "answer": "Yes, puff panels are highly energy-efficient. They help maintain the temperature of the room, reducing the need for constant heating or cooling. This can result in lower energy costs over time."
    },
    {
      "question": "Are puff panel rooms easy to maintain?",
      "answer": "Yes, puff panel rooms are low-maintenance. The panels are easy to clean, resistant to dust and moisture, and provide long-lasting insulation benefits with minimal upkeep."
    },
    {
      "question": "Is puff panel installation suitable for both residential and commercial spaces?",
      "answer": "Absolutely! Puff panel rooms are ideal for both residential and commercial spaces, including offices, conference rooms, homes, factories, and more. They offer both aesthetic appeal and functional benefits for any setting."
    },
    {
      "question": "How do puff panels improve sound insulation?",
      "answer": "Puff panels are designed with materials that absorb and reduce sound transmission, making them ideal for rooms where noise reduction is important, such as offices, recording studios, and conference rooms."
    },
    {
      "question": "What types of designs can I choose for my puff panel room?",
      "answer": "Puff panels come in a variety of colors, textures, and finishes. We offer custom designs to match the style of your space, whether you're looking for a sleek, modern look or something more traditional."
    },
    {
      "question": "Why should I choose Anjali Enterprises for puff panel room installation?",
      "answer": "Anjali Enterprises is known for its expertise in providing high-quality puff panel rooms. We offer customized solutions, professional installation, and excellent customer service. Our team is committed to delivering a finished product that meets your specific needs while maintaining high standards of quality."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Raghav Desai",
      "text": "The puff panel room installed by Anjali Enterprises exceeded our expectations. The insulation is excellent, and the room looks modern and stylish. The team was professional, and the installation process was smooth and hassle-free."
    },
    {
      "name": "Ms. Shweta Kapoor",
      "text": "I wanted to create a quiet, comfortable room in my home, and Anjali Enterprises did a fantastic job with the puff panel installation. The room is now perfectly insulated, and the overall look is just what I wanted!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title>Puff Panel Room Installation in Pune</title>
  <meta name="description" content="Anjali Enterprises offers puff panel room installation, insulated panel room design, modular puff panel rooms, cold storage rooms, and high-quality puff panel construction in Pune. Call +91 8793220265 for customized puff panel room solutions." />
  <meta name="keywords" content="Puff Panel Room Installation, Insulated Panel Room Design, Puff Panel Fabrication, Modular Puff Panel Rooms, Cold Storage Rooms with Puff Panels, High-Quality Puff Panel Installation, Custom Puff Panel Solutions, Insulated Walls for Industrial Use, Puff Panel Partition Services, Puff Panel Work for Commercial Spaces, Durable Puff Panel Room Construction" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Puff Panel Room Installation in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers puff panel room installation, insulated panel room design, modular puff panel rooms, cold storage rooms, and high-quality puff panel construction in Pune. Call +91 8793220265 for customized puff panel room solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/puff-panel-room.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/puff-panel-room-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers puff panel room installation, insulated panel room design, modular puff panel rooms, cold storage rooms, and high-quality puff panel construction in Pune. Call +91 8793220265 for customized puff panel room solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/puff-panel-room-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/puff-panel-room.jpg",
        "priceRange": "₹5000 - ₹20000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/puff-panel-room-installation",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "40"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh M"
            },
            "datePublished": "2024-07-10",
            "reviewBody": "We had a puff panel room installed for cold storage, and Anjali Enterprises did an amazing job. The room was built to last, and the insulation is top-notch. Great service and professionalism!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sandeep K"
            },
            "datePublished": "2024-08-22",
            "reviewBody": "Anjali Enterprises handled our modular puff panel room project excellently. The room was constructed with high-quality materials, and their team completed it on time. Very happy with the results."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/puff-panel-room-installation"
        },
        "keywords": "Puff Panel Room Installation, Insulated Panel Room Design, Puff Panel Fabrication, Modular Puff Panel Rooms, Cold Storage Rooms with Puff Panels, High-Quality Puff Panel Installation, Custom Puff Panel Solutions, Insulated Walls for Industrial Use, Puff Panel Partition Services, Puff Panel Work for Commercial Spaces, Durable Puff Panel Room Construction"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/22.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Puffpanelroom;